// extracted by mini-css-extract-plugin
export default {"root":"ConfirmModal_root__ggUW-","container":"ConfirmModal_container__nniaE","body":"ConfirmModal_body__kVEap","footer":"ConfirmModal_footer__UVXqd"};